import { t } from "i18next";

import { Box, Button, CircularProgress, Typography } from "@mui/material";

interface FeedbackFormActionsProps {
  isFormDisabled: boolean;
  isValid: boolean;
  progressText: string | null;
  onReset: () => void;
}

const FeedbackFormActions = ({
  isFormDisabled,
  isValid,
  progressText,
  onReset
}: FeedbackFormActionsProps) => {
  return (
    <>
      {isFormDisabled && progressText && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 1 }}>
          <CircularProgress size={20} />
          <Typography
            variant="body2"
            sx={(muiTheme) => ({
              color: muiTheme.palette.text.secondary
            })}
          >
            {progressText}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isFormDisabled || !isValid}
        >
          {t("feedbackForm.buttons.send")}
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          disabled={isFormDisabled}
          onClick={onReset}
        >
          {t("feedbackForm.buttons.clear")}
        </Button>
      </Box>
    </>
  );
};

export default FeedbackFormActions;
